import React, { useState, useRef, useEffect } from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function getScrollableLength(
  container: HTMLDivElement | null,
  text: HTMLDivElement | null,
) {
  const cWidth = container ? container.getBoundingClientRect().width : 0;
  const tWidth = text ? text.getBoundingClientRect().width : 0;

  return cWidth - tWidth;
}

function getScrollDuration(distance: number, speed: number) {
  return (Math.abs(distance) / speed) * 1000;
}

function ScrollingText({ speed = 50, children }: Props) {
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const [scrollDuration, setScrollDuration] = useState(0);

  useEffect(() => {
    const distance = getScrollableLength(containerRef.current, textRef.current);
    const duration = getScrollDuration(distance, speed);

    setScrollDuration(duration);
  }, [children, speed]);

  return (
    <div
      ref={containerRef}
      className={styles.scrollingText}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        ref={textRef}
        className={styles.slider}
        style={
          isHovered
            ? {
                transition: `transform ${scrollDuration}ms linear`,
                transform: `translateX(${getScrollableLength(
                  containerRef.current,
                  textRef.current,
                )}px)`,
              }
            : {
                transition: `initial`,
              }
        }
      >
        {children}
      </div>
    </div>
  );
}

export { ScrollingText };
